import {OrderTrackingStatus} from "../../../../../services/Api/types";

const statuses = [
    OrderTrackingStatus.PREPARATION,
    OrderTrackingStatus.READY,
    OrderTrackingStatus.RECEIVED,
]

export const getRestOfPreparationStatuses = (trackingStatus: OrderTrackingStatus) => {
    const currentStatusIndex = statuses.indexOf(trackingStatus);

    return statuses.filter((_, index) => index >= currentStatusIndex);
}